import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IOpportunityEmail } from "../../utils/types/models";

export default createEntityReducer<IOpportunityEmail>(Endpoint.OpportunityEmails, Endpoint.OpportunityEmailsList);
